import { merge } from 'lodash';

import { DefaultBuildConfig } from '../variants/_defaults/build.config';

/**
 * DO NOT EDIT THIS FILE
 *
 * Each customers build.config.js overrides the DefaultBuildConfig
 * the active customer variant of the build.config.js will be globally loaded
 * and merged over the defaults to produce the final BuildConfig
 *
 */
export default window.APP_CONFIG; // eslint-disable-line
export const BuildConfig = merge({}, DefaultBuildConfig, window.BuildConfig); // eslint-disable-line
